<template>
  <div class="w-full">
    <div
      class="learning-hub-container relative border-1 rounded-2xl min-w-full min-h-[60vh] tablet:min-h-[80vh] laptop:min-h-[100vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-4 pb-5 border-gray-300">
      <div class="relative z-10 mobile:w-full flex tablet:justify-end items-center gap-2 tablet:left-auto -mt-[43px]">
        <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[300px]'"
          :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
          :buttonclass="'absolute top-1.5 right-1 w-7 h-7'" :img-src="require('@/assets/images/search-icon-01.png')"
          :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
          v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
      </div>
      <!-- Gallery Grid - Fixed 4 per row -->
      <div v-if="list.length > 0" class="gallery-wrapper">
        <div class="gallery-grid-container">
          <div v-for="(item, index) in list" :key="index" class="media-card w-full bg-white rounded-[16px] overflow-hidden 
       shadow-[0_4px_20px_rgba(0,0,0,0.04)]
       transition-[transform,box-shadow,border-color] duration-[400ms] ease-[cubic-bezier(0.4,0,0.2,1)]
       border-[1px] border-[#f0f0f0] laptop:hover:border-customBlue-100
       laptop:hover:-translate-y-[10px]
       laptop:hover:shadow-[0_20px_40px_rgba(0,0,0,0.1)]
       will-change-transform transform-gpu">
            <a :href="item.main_file_src" 
               :data-fancybox="(item.file_type === 'documents' && isMobile) ? null : `gallery-${index}`"
               :data-caption="item.file_type !== 'documents' ? `<h3>${item.title}</h3><p>${item.description}</p>` : ''"
               :data-type="item.file_type === 'documents' ? 'pdf' : (item.file_type === 'video' ? 'html5video' : undefined)"
               :target="(item.file_type === 'documents' && isMobile) ? '_blank' : undefined"
               class="no-underline hover:no-underline text-inherit block p-[10px]">
              <div class="h-[180px] w-full relative overflow-hidden rounded-[10px]">
                <img :src="getThumbnail(item)" :alt="item.title" class="thumbnail-img rounded-[10px]" />
                <div
                  class="absolute right-3 bottom-3 w-[40px] h-[40px] flex justify-center items-center rounded-full bg-black-100/50">
                  <img v-if="item.file_type === 'video'" src="../../assets/images/videoplay-btn.svg"
                    class="w-[18px] h-[18px] object-cover" alt="icon">
                  <img v-else-if="item.file_type === 'documents'" src="../../assets/images/pdfpreview-btn.svg"
                    class="w-[20px] h-[20px] object-cover" alt="icon">
                  <img v-else src="../../assets/images/imgpreview-btn.svg" class="w-[20px] h-[20px] object-cover"
                    alt="icon">
                </div>
              </div>
              <div class="font-roboto pt-[10px]">
                <h4
                  class="text-[12px] font-normal text-customBlue-100 m-0 whitespace-nowrap overflow-hidden text-ellipsis !mb-[2px]">
                  {{ item.title }}</h4>
                <p
                  class="text-[14px] font-normal text-[#666666] leading-[1.2] line-clamp-2 overflow-hidden m-0 ! mb-[5px]">
                  {{ item.description }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <h6 v-else
        class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] largeDesktop:min-h-[80vh] m-0 text-[#333333]">
        No Record Found
      </h6>

    </div>
    <div class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import searchInput from '../../components/partialComponent/customInput.vue';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import pdfThumb from "../../assets/images/pdf-thumb.svg"

export default {
  name: "GalleryView",
  components: {
    searchInput,
    customPagination,
    paginationEntries
  },
  data() {
    return {
      searchQuery: '',
      limit: 50,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      list: [],
      debounceTimer: null,
      loading: false,
      isMobile: window.innerWidth < 1024
    };
  },
  computed: {
    ...mapGetters(["mediaFiles"]),

  },

  watch: {
    mediaFiles: function (data) {
      this.loading = false
      this.list = this.mediaFiles.body
      this.total_pages = this.mediaFiles.paging.total_pages
      this.totalItems = this.mediaFiles.paging.total_records
    }
  },

  mounted() {
    this.loading = true
    this.getMediaFiles({
      "search": this.search,
      "limit": this.limit,
      "page": this.page
    })
    window.addEventListener('resize', this.updateDeviceType);
    Fancybox.bind("[data-fancybox]", {
      compact: false,
      animated: false,
      Carousel: {
        transition: "fade",
        friction: 0,
      },
      Images: {
        zoom: true,
        Panzoom: {
          maxScale: 3,
        },
        dragToClose: false,
      },
      Html: {
        dragToClose: false,
      },
      Toolbar: {
        autoHide: false,
        display: {
          left: [],
          middle: [],
          right: ["zoomIn", "zoomOut", "close"],
        },
      },
      Navigation: false,
      Thumbs: false,
      backdropClick: false,
      contentClick: false,
      click: false,
      Click: {
        outside: false,
        slide: false,
        content: false,
      },
      Keyboard: {
        Escape: false,
      },
      autoFocus: true,
      trapFocus: true,
      placeFocusBack: true,
      Hash: false,
      dragToClose: false,
      on: {
        destroy: (fancybox) => {
          // Additional cleanup if needed
        },
      },
    });
  },
  unmounted() {
    window.removeEventListener('resize', this.updateDeviceType);
    Fancybox.destroy();
  },
  methods: {
    ...mapActions(["getMediaFiles"]),

    getThumbnail(item) {
      if (item.file_type === 'documents') {
        return pdfThumb;
      } else {
        return item.thumbnail_src;
      }
    },

    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getMediaFiles({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });
    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getMediaFiles({
            "search": this.search,
            "limit": this.limit,
            "page": this.page
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.search = ''
      this.loading = true
      this.getMediaFiles({
        "search": this.search,
        "limit": this.limit,
        "page": this.page
      });

    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getMediaFiles({
        search: this.search,
        limit: this.limit,
        page: this.page,
      });
    },
    updateDeviceType() {
      this.isMobile = window.innerWidth < 1024;
    },
  }
};
</script>

<style>
/* --- Premium Gallery Viewer Overrides --- */

.fancybox__container {
  --fancybox-bg: rgba(0, 0, 0, 0.85);
  --f-button-bg: rgba(255, 255, 255, 0.1);
  --f-button-color: #fff;
  --f-button-hover-bg: #0046af;
}

.fancybox__content {
  background: #fff !important;
  border-radius: 12px !important;
  padding: 0 !important;
  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.5);
}

/* Caption Footer Fixed at Bottom */
.fancybox__caption {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  padding: 20px 40px !important;
  background: #fff !important;
  color: #333 !important;
  text-align: left !important;
  border-top: 1px solid #f0f5ff;
  z-index: 5000 !important;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.1) !important;
  max-height: 250px;
  overflow-y: auto;
}

.fancybox__container.is-compact .has-iframe .fancybox__content,
.fancybox__container.is-compact .has-map .fancybox__content,
.fancybox__container.is-compact .has-pdf .fancybox__content {
  width: 100% !important;
  height: 100% !important;
}

.has-pdf .fancybox__content {
  width: 100% !important;
  height: calc(100% - 40px) !important;
  max-width: 100% !important;
  margin-top: 40px !important;
  margin-bottom: 0 !important;
  border-radius: 0 !important;
}

.fancybox__slide.has-pdf {
  padding: 0 !important;
}

.fancybox__slide {
  padding-bottom: 120px !important;
}

.caption-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.fancybox__caption h3 {
  color: #0046af !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-family: 'Outfit', sans-serif;
}

.caption-badge {
  background: #eef4ff;
  color: #0046af;
  padding: 4px 12px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Ensure caption never hides on click */
.fancybox__caption,
.fancybox__container.is-compact .fancybox__caption {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* Hide document caption separately */
.has-pdf .fancybox__caption {
  display: none !important;
}

.caption-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f8f8f8;
  padding-top: 10px;
}

.caption-date {
  font-size: 11px;
  color: #aaa;
  font-weight: 500;
}

.caption-date i {
  margin-right: 5px;
}

/* PDF/Video specific viewer tweaks */
.fancybox__html5video,
.fancybox__iframe {
  background: #000;
}

.fancybox__html5video:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* Gallery Grid Styling - 4 per row */
.gallery-wrapper {
  position: relative;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
}

.gallery-grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  padding: 10px 0 40px;
  contain: layout style; /* Performance optimization */
}

.media-card {
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

.fancybox__toolbar__column.is-right {
  gap: 5px;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backface-visibility: hidden;
  will-change: transform;
}
@media (min-width: 1024px) {
  .media-card:hover .thumbnail-img {
    transform: scale(1.05);
  }
}
@media (max-width: 1280px) {
  .gallery-grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .gallery-grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
  .has-pdf .fancybox__content {
  height: calc(100% - 60px) !important;
  margin-top: 60px !important;
}
}

@media (max-width: 576px) {
  .gallery-grid-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .fancybox__slide {
    padding-bottom: 150px !important;
  }
}

.fancybox__toolbar {
  position: fixed !important;
  right: 15px !important;
  top: 10px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  z-index: 100000 !important;
  height: auto !important;
  width: auto !important;
  background: transparent !important;
}

.fancybox__toolbar .f-button {
  background: #3c3c3c !important;
  color: #fff !important;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2) !important;
}

.fancybox__toolbar .f-button[data-fancybox-close] {
  background: #3c3c3c !important;
}

.fancybox__toolbar .f-button:hover {
  background: #0046af !important;
}

/* Ensure toolbar and caption never hide on click (Mobile/all devices) */
.fancybox__toolbar,
.fancybox__caption,
.is-compact .fancybox__toolbar,
.is-compact .fancybox__caption,
.is-controls-hidden .fancybox__toolbar,
.is-controls-hidden .fancybox__caption,
.fancybox__container.is-animated .fancybox__toolbar,
.fancybox__container.is-animated .fancybox__caption {
  opacity: 1 !important;
  visibility: visible !important;
  display: flex !important;
  pointer-events: auto !important;
}

.fancybox__caption {
  display: block !important;
}

.is-compact .fancybox__content>.f-button.is-close-btn {
    display: none !important;
}
</style>